import { Grid } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'
import { makeBreakable } from 'lib/util/string'
import Text from 'ui/Element/Text'

const styles = () => ({
  container: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
})

/**
 * Displays a description.
 *
 * @param {Object} classes  element's style classes
 * @param {Object} props    element's properties
 *
 * @returns {JSX.Element}
 */
export const ListItemCellFavoriteDescription = (classes, props = {}) => {
  const { favoriteDescription } = props

  return (
    <Grid
      container
      className={classes.container}
    >
      <Grid
        item
        xs={'auto'}
        maxLines={2}
        component={Text}
        color={'black.main'}
        variant={'14/medium'}
        value={makeBreakable(favoriteDescription || '-')}
      />
    </Grid>
  )
}

export default CellHOC(ListItemCellFavoriteDescription, styles)
